import styled from 'styled-components'

const Section = styled.div`
  padding: 15px 10px;
  border-bottom: 1px solid ${props => props.theme.color.monochrome.light};

  ul {
    margin-bottom: 12px;
  }
  ul li {
    list-style: outside;
    margin-left: 2em;
  }
`

const DrawerContentWrapper = styled.div`
  padding: 0 5px;
`

export { Section, DrawerContentWrapper }
